export enum TipoOrtorgarConcesion {
    INMEDIATAMENTE = "INMEDIATAMENTE",
    PATRON_DE_FECHAS = "PATRON_DE_FECHAS"
}